import React from "react";
import { Container, ContainerFluid } from "../components/Wrapper.js";
import Header from "../components/headers/Header.js";
import Footer from "../components/footers/Footer.js";
import Tractor from "../components/Tractors.js";

export default function TractorPage(){
  return (
    <Container>
      <Header isActiveTab="3" />
      <ContainerFluid>
        <Tractor />
      </ContainerFluid>
      <ContainerFluid>
        <Footer />
      </ContainerFluid>
    </Container>
  );
};